import { JsonObject, JsonProperty } from "ta-json";

import Link from "../link";

@JsonObject()
export default class Resource {
    @JsonProperty("self")
    self: Link;
    // // @JsonProperty("modified")
    // // @JsonReadonly()
    // // modifiedOn?: Date;
}

export { Resource };
